import { toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

const providerDependantEntities = [
  'agency_provider_packages',
  'agency_order_bundles',
  'agency_publications',
  'quote_templates',
  'default_quote_items',
]

const quoteTemplateDependantEntities = [
  'agency_provider_packages',
  'agency_order_bundles',
  'quote_templates',
]

const defaultQuoteItemsDependantEntities = [
  'agency_providers',
  'agency_provider_packages',
  'agency_order_bundles',
  'quote_templates',
]

const selectableEntities = [
  { key: 'agency_providers', label: 'Providers & Price Lists' },
  { key: 'agency_provider_packages', label: 'Packages (Requires Provider & Price Lists)' },
  { key: 'agency_order_bundles', label: 'Bundles (Requires Provider & Price Lists)' },
  { key: 'agency_publications', label: 'Publications (Requires Provider & Price Lists)' },
  { key: 'quote_templates', label: 'Quote Templates (Requires Provider & Price Lists, Bundles, and Packages)' },
  {
    key: 'default_quote_items',
    label: 'Default Quote Items (Requires Provider & Price Lists, Bundles, Packages and Quote Templates)',
  },
  { key: 'agency_template_pages', label: 'Templates' },
  { key: 'agency_options', label: 'Agency Admin Settings' },
  { key: 'quotes_and_invoicing', label: 'Quotes & Invoicing' },
]

type DefaultState = {
  selectedEntityKeys: string[],
  sourceAgencyId: null | number,
}

type ToggleEntityParams = {
  selectedEntityKeys: string[],
  selectedEntity: string,
  setState: (state: Partial<DefaultState>) => void,
}

const toggleEntity = (params: ToggleEntityParams) => {
  const { selectedEntityKeys, selectedEntity, setState } = params

  let updatedEntities = toggleArray(selectedEntityKeys, selectedEntity)

  if (selectedEntity === 'agency_providers' && !updatedEntities.includes('agency_providers')){
    updatedEntities = updatedEntities.filter(key => !providerDependantEntities.includes(key))
  }

  // Quote Templates
  if (quoteTemplateDependantEntities.some(entity => !updatedEntities.includes(entity))){
    updatedEntities = updatedEntities.filter(entity => entity !== 'quote_templates')
  }

  // Default Quote items
  if (defaultQuoteItemsDependantEntities.some(entity => !updatedEntities.includes(entity))){
    updatedEntities = updatedEntities.filter(entity => entity !== 'default_quote_items')
  }

  setState({ selectedEntityKeys: updatedEntities })
}

const defaultState: DefaultState = {
  selectedEntityKeys: [
    'agency_providers',
    'agency_options',
    'agency_order_bundles',
    'agency_provider_packages',
    'agency_publications',
    'agency_template_pages',
    'default_quote_items',
    'quote_templates',
    'quotes_and_invoicing',
  ],
  sourceAgencyId: null,
}

const useCopyAgencyDataModal = () => {
  const [state, setState] = useSetState(defaultState)
  const { selectedEntityKeys, sourceAgencyId } = state

  return {
    callbacks: {
      setState,
      toggleEntity: ({ selectedEntity }: { selectedEntity: string }) => toggleEntity(
        { selectedEntityKeys, selectedEntity, setState },
      ),
    },
    providerDependantEntities,
    selectedEntityKeys,
    sourceAgencyId,
    selectableEntities,
  }
}

export default useCopyAgencyDataModal
